class Slideshow extends HTMLElement {
  constructor() {
    super();

    this.slide = this.querySelector('.js-slideshow');
    if(this.slide.hasAttribute('auto-play')){
      this.timerValue = this.slide.getAttribute('auto-play');
      this.time = parseInt(this.timerValue * 1000);
    }
    this.swiperSlide = this.querySelectorAll('.js-slideshow .swiper-slide');
    if(this.swiperSlide.length > 1){
      if(this.slide.hasAttribute('auto-play')){
        new Swiper(this.slide, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 1000,
          autoHeight: false,
          autoplay: {
            delay: this.time,
            disableOnInteraction: false,
          },
          // Navigation arrows
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
        });
      } else {
        new Swiper(this.slide, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: false,
          speed: 1000,
          // Navigation arrows
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
        });
      }
    } else {
      this.slide.querySelector('.swiper-button-next').classList.add('swiper-button-none');
      this.slide.querySelector('.swiper-button-prev').classList.add('swiper-button-none');
      new Swiper(this.slide, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        autoHeight: false,
      });
    }
  }
}
customElements.define("slideshow-banner", Slideshow)